import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "https://tgsh.geometricsoft.com/api/",
});

API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("access_token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Let axios decide content type automatically
        if (config.data instanceof FormData) {
            delete config.headers["Content-Type"];
        }

        return config;
    },
    (error) => Promise.reject(error)
);

API.interceptors.response.use(
    (response) => response,
    (error) => {
        // Optional: Handle 401 globally
        if (error.response?.status === 401) {
            localStorage.removeItem("access_token");
            // window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export default API;